import useFormStateWithErrors from '@gr-monorepo/common/utils/useFormStateWithErrors';

export const vectorSurveyDefaultState = {
  answer_1: '',
  answer_2: '',
  answer_3: '',
  answer_4: '',
  answer_5: '',
  answer_6: '',
  answer_7: '',
  answer_8: '',
  answer_9: '',
  answer_10: '',
};

export const vectorSurveyDefaultErrorState = {
  answer_1: null,
  answer_2: null,
  answer_3: null,
  answer_4: null,
  answer_5: null,
  answer_6: null,
  answer_7: null,
  answer_8: null,
  answer_9: null,
  answer_10: null,
};

export const useVectorSurveyState = () =>
  useFormStateWithErrors(vectorSurveyDefaultState, vectorSurveyDefaultErrorState);
